import React from 'react';
import PropTypes from 'prop-types';
import { Select, Form } from 'antd';

const generateTimeOptions = () => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const displayHour = hour % 12 === 0 ? 12 : hour % 12;
      const period = hour < 12 ? 'am' : 'pm';
      const formattedTime = `${displayHour}:${minute.toString().padStart(2, '0')}${period}`;
      times.push(formattedTime);
    }
  }
  return times;
};

const TimePickerDropdown = ({
  label,
  name,
  initialValue,
  rules = [],
  allowClear = false,
  dependencies = [],
  onChange,
}) => {
  const timeOptions = generateTimeOptions();

  return (
    <Form.Item
      label={label}
      name={name}
      dependencies={dependencies}
      initialValue={initialValue}
      rules={rules}
    >
      <Select
        style={{ width: '100%' }}
        allowClear={allowClear}
        onChange={onChange}
        options={timeOptions.map((time) => ({
          value: time,
          label: time,
        }))}
      />
    </Form.Item>
  );
};

TimePickerDropdown.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  initialValue: PropTypes.string,
  rules: PropTypes.array,
};

export default TimePickerDropdown;
